import viewsIcon from '@disy/cadenza-icons/views.svg';

import { Modal } from 'ui/dialog/modal/modal';

import { createProcessesContent } from 'cadenza/processes/processes';
import { icon } from 'cadenza/utils/icon/icon';

import './processes-dialog.css';
import i18n from './messages.properties';

const COMPONENT_NAME = 'd-processes-dialog';

export class ProcessesDialog extends Modal {

  constructor (processesLoader) {
    super({ title: i18n('processDialogTitle'), titleIcon: icon(viewsIcon) });
    this.classList.add(COMPONENT_NAME);
    this.body.append(createProcessesContent(processesLoader));
  }

}

customElements.define(COMPONENT_NAME, ProcessesDialog);
